var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M3 8.625h4.025V21H3V8.625zM17.99 8.77c-.043-.013-.084-.028-.129-.04-.054-.013-.108-.023-.163-.032-.238-.048-.48-.073-.722-.073-2.347 0-3.835 1.707-4.326 2.366V8.625H8.625V21h4.025v-6.75s3.042-4.237 4.326-1.125V21H21v-8.35c-.002-.89-.298-1.752-.843-2.454-.545-.702-1.307-1.204-2.168-1.426zM4.969 6.938c1.087 0 1.968-.882 1.968-1.97C6.938 3.882 6.058 3 4.97 3S3 3.881 3 4.969c0 1.087.881 1.968 1.969 1.968z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-linkedin.6537afc5.svg";
export { ForwardRef as ReactComponent };